import * as React from 'react';
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { getInboxClassificationFilterForTable } from 'owa-mail-list-store';
import renderInboxPivot from './InboxPivot';
import { getInboxPlusPivots, selectInboxPivot } from 'owa-mail-inbox-plus-store';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { observer } from 'mobx-react';
import { InboxClassificationFilter } from 'owa-mail-list-store';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import { lazyShowPivotReorderDialog } from 'owa-mail-inbox-plus-dialog';

const styles = require('./InboxPlusHeader.scss');

export interface InboxPlusHeaderProps {
    tableViewId: string;
}

@observer
export default class InboxPlusHeader extends React.Component<InboxPlusHeaderProps, {}> {
    render() {
        const enabledPivots = getInboxPlusPivots().filter(pivotType => pivotType.isEnabled);
        const currentClassificationFilter = getInboxClassificationFilterForTable(
            this.props.tableViewId
        );
        const selectedKey = convertClassificationFiltertoPivotKey(currentClassificationFilter);

        return (
            <div className={styles.focusedOtherContainer}>
                <Pivot
                    onLinkClick={this.onPivotItemClicked}
                    styles={this.calculateCustomPivotStyle}
                    selectedKey={selectedKey}>
                    {enabledPivots.map(pivot => renderInboxPivot(pivot.InboxClassificationFilter))}
                </Pivot>
                <IconButton
                    onClick={evt => this.onClickAddButton(evt)}
                    iconProps={this.getIconProps()}
                />
            </div>
        );
    }

    private onPivotItemClicked = (item: PivotItem) => {
        const focusedViewFilterToSelect = this.convertPivotKeyToClassificationViewFilter(
            item.props.itemKey
        );
        selectInboxPivot(focusedViewFilterToSelect, this.props.tableViewId);
    };

    private calculateCustomPivotStyle = () => {
        return {
            link: styles.nonSelectedPivotLink,
            linkIsSelected: styles.selectedPivotLink,
            linkContent: styles.linkContent,
            text: styles.text,
        };
    };

    /**
     * Convert pivot key string back to the focused view filter to select
     * @param key of the pivot component
     */
    private convertPivotKeyToClassificationViewFilter = (
        key: string
    ): InboxClassificationFilter => {
        switch (key) {
            case 'inbox':
                return InboxClassificationFilter.None;
            case 'focused':
                return InboxClassificationFilter.Focused;
            case 'promotions':
                return InboxClassificationFilter.Promotions;
            case 'newsletters':
                return InboxClassificationFilter.Newsletters;
            case 'social':
                return InboxClassificationFilter.Social;
            case 'other':
                return InboxClassificationFilter.Other;
            default:
                throw new Error('Invalid inbox plus pivot');
        }
    };

    private onClickAddButton = async (e: any) => {
        e.stopPropagation();
        const showPivotReorderDialog = await lazyShowPivotReorderDialog.import();
        showPivotReorderDialog();
    };

    private getIconProps = (): IIconProps => {
        return {
            iconName: ControlIcons.Add,
            styles: {
                root: styles.reorderPivotButton,
            },
        };
    };
}

/**
 * Convert the inbox classification filter to a string that used as the key in Pivot fabric component
 * We need to do this instead of just using the InboxClassificationFilter value, because FocusedViewFilter.None(-1) is ignored by the Fabric Pivot
 */
export function convertClassificationFiltertoPivotKey(
    classificationFitler: InboxClassificationFilter
): string {
    switch (classificationFitler) {
        case InboxClassificationFilter.None:
            return 'inbox';
        case InboxClassificationFilter.Focused:
            return 'focused';
        case InboxClassificationFilter.Promotions:
            return 'promotions';
        case InboxClassificationFilter.Newsletters:
            return 'newsletters';
        case InboxClassificationFilter.Social:
            return 'social';
        case InboxClassificationFilter.Other:
            return 'other';
        default:
            throw new Error('Invalid inbox plus pivot');
    }
}
